export default 'https://tme.understood.org/assets/collectible.15788fa2.glb'